import React from "react";
import {
  NewsletterSignupBase,
  NewsletterText,
  NewsletterSignupContent,
  InputLabel,
  Disclaimer,
  FormWrapper,
} from "./newsletter-signup.styled";
import { NewsletterSignupSliceFragment } from "../../types/graphql";
import loadable from "@loadable/component";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import { htmlSerializer } from "../../utils/htmlSerializer";

// Lazy load newsletter form since Formik and Yup bloat bundle sizes
const NewsletterForm = loadable(
  () => import("../newsletter-form/newsletter-form")
);

export type INewsletterSignupProps = Slice<
  SharedSliceType,
  NewsletterSignupSliceFragment["primary"]
> & { type: SharedSliceType };

const NewsletterSignup = ({
  slice,
}: SliceComponentProps<INewsletterSignupProps, IPageContext>) => {
  const newsletter = slice.primary;

  return (
    <NewsletterSignupBase className="slice-section">
      <NewsletterSignupContent className="container grid">
        <div className="col-span-4 md-col-span-3 lg-col-span-5">
          {newsletter?.description && (
            <header>
              <NewsletterText>{newsletter?.description}</NewsletterText>
            </header>
          )}
        </div>
        <div className="col-span-4 md-col-span-5 lg-col-span-6">
          <FormWrapper>
            {newsletter?.form_title && (
              <InputLabel>{newsletter?.form_title}</InputLabel>
            )}
            <NewsletterForm
              ctaKind="primary"
              ctaScale="large"
              eventPageSection="signup"
              inputScale="large"
              alignment="end"
            />
            {newsletter?.disclaimer &&
              newsletter?.disclaimer.richText.length > 0 && (
                <Disclaimer>
                  <PrismicRichText
                    field={newsletter?.disclaimer.richText}
                    components={htmlSerializer}
                  />
                </Disclaimer>
              )}
          </FormWrapper>
        </div>
      </NewsletterSignupContent>
    </NewsletterSignupBase>
  );
};

export default NewsletterSignup;
